<script setup lang="ts">
import { useHead } from '@vueuse/head'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { TheBanner, TheBooking, TheEcology, TheHospitality, TheProject, TheVideo } from '~/components/front-page'

const { t } = useI18n()

useHead({
  title: computed(() => t('project.name')),
})
</script>

<template>
  <div>
    <TheBanner />
    <main id="content" class="lg:-mt-20 lg:pt-20">
      <TheProject />
      <TheVideo />
      <TheEcology />
      <TheHospitality />
      <TheBooking />
    </main>
  </div>
</template>
